import { PetTypeIds } from '@spike/model';
import { PetTypeIcon } from 'components/UI/V3/PetTypeIcon/PetTypeIcon';
import { WaitlistPet } from 'model/Waitlist';
import { FunctionComponent } from 'react';
import styles from './WaitlistPetAvatar.module.scss';

interface WaitlistPetAvatarProps {
    pet: Pick<WaitlistPet, 'name' | 'image' | 'type'>;
    size?: number;
}

const PET_TYPE_IDS: Array<string> = Object.values(PetTypeIds);

export const WaitlistPetAvatar: FunctionComponent<WaitlistPetAvatarProps> = ({ pet, size = 44 }) => {
    if (pet.image) {
        return (
            <img
                src={pet.image}
                alt={pet.name}
                className={styles.image}
                style={{ width: size, height: size }}
            />
        );
    }

    const typeId = PET_TYPE_IDS.includes(pet.type) ? pet.type : PetTypeIds.DOGS;

    return (
        <PetTypeIcon
            size={size}
            variant="light"
            type={{ id: typeId, singular: typeId, plural: typeId }}
        />
    );
};

export default WaitlistPetAvatar;
